import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { useI18n } from "../../lib/i18n";
import { Sparkles, Crown } from "lucide-react";

export const UpgradeModal = ({ open, onOpenChange }) => {
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0a0a0a] border-bull/40 rounded-none max-w-2xl p-0 overflow-hidden" data-testid="upgrade-modal">
        <div className="p-8">
          <DialogTitle className="text-2xl sm:text-3xl font-semibold tracking-tighter">
            {t("upgrade_title")}<span className="text-bull">_</span>
          </DialogTitle>
          <DialogDescription className="mt-3 text-neutral-400">{t("upgrade_subtitle")}</DialogDescription>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
            <button
              onClick={() => { onOpenChange(false); navigate("/pricing"); }}
              className="text-left border-2 border-bull bg-bull/[0.05] p-5 hover:bg-bull/10 transition-colors"
              data-testid="modal-upgrade-trader"
            >
              <div className="flex items-center justify-between">
                <span className="label-mono text-bull">{t("plan_TRADER")}</span>
                <Sparkles className="h-4 w-4 text-bull" strokeWidth={1.5} />
              </div>
              <div className="mt-3 flex items-baseline gap-1">
                <span className="font-mono text-3xl font-medium">$19.99</span>
                <span className="font-mono text-xs text-neutral-400">{t("pricing_per_month")}</span>
              </div>
              <p className="mt-1 text-xs text-neutral-400">{t("pricing_analyses_100")}</p>
              <div className="mt-4 font-mono text-xs text-bull">{t("pricing_trader_cta")} →</div>
            </button>
            <button
              onClick={() => { onOpenChange(false); navigate("/pricing"); }}
              className="text-left border border-white/15 bg-white/[0.02] p-5 hover:bg-white/[0.05] transition-colors"
              data-testid="modal-upgrade-pro"
            >
              <div className="flex items-center justify-between">
                <span className="label-mono">{t("plan_PRO")}</span>
                <Crown className="h-4 w-4 text-warn" strokeWidth={1.5} />
              </div>
              <div className="mt-3 flex items-baseline gap-1">
                <span className="font-mono text-3xl font-medium">$99.99</span>
                <span className="font-mono text-xs text-neutral-400">{t("pricing_per_month")}</span>
              </div>
              <p className="mt-1 text-xs text-neutral-400">{t("pricing_analyses_unlimited")}</p>
              <div className="mt-4 font-mono text-xs text-white">{t("pricing_pro_cta")} →</div>
            </button>
          </div>

          <Button
            variant="ghost"
            className="mt-6 w-full text-neutral-500 hover:text-white hover:bg-white/5 rounded-none"
            onClick={() => onOpenChange(false)}
            data-testid="modal-later-btn"
          >
            {t("upgrade_maybe_later")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
